import React,{useState,useEffect} from 'react';
import axios from 'axios';
import jwt_decode from "jwt-decode";
import {useNavigate, useLocation} from "react-router-dom";
import { toast } from 'react-toastify';
import PacmanLoader from "react-spinners/PacmanLoader";
import Select from 'react-select'
// import { count } from '@progress/kendo-data-query/dist/npm/array.operators';

const styleTittle = {

    fontSize: 20,
    color: "#4a54f1",
    textAlign: "center",
    paddingBottom: "20px",
    paddingTop: "30px"
}

const stylespinner = {
  position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)"
}

const TambahBarang = () => {
    const [token, setToken] = useState("");
    const [expire, setExpire] = useState("");
    const [idBarang, setIdBarang] = useState(null);
    const [namaBarang, setNamaBarang] = useState("");
    const [qty, setQty] = useState("");
    const [suplier, setSuplier] = useState("");
    const [keterangan, setKeterangan] = useState("");
    const [user, setUser] = useState("");
    const [jumlahstok, setJumlahStok] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [barang,setBarang] = useState([]);
    const location = useLocation();
    const cabang = location.state?.cabang;


const getBarang = async () => {
    const response = await axiosJWT.get(`${process.env.REACT_APP_MASTER_URL}/barang`,{
                params: {
                    cabang: cabang
                }
            });
    setBarang(response.data[0]);
}

const options =  barang.map(brg=>({
        "value": brg.idBarang,
        "label": brg.namaBarang 
  }))


  const handleChange = (selectedOption) =>{
    // console.log("select : ", selectedOption.value);
    // console.log(e.target.value);
    let kode = selectedOption.value;
    setIdBarang(kode);  
    // console.log("ini kode : ",kode);
    const getBarangByIdBarang = async () =>{
        const response = await axios.get(`${process.env.REACT_APP_MASTER_URL}/barangmasuk/${kode}`)
        setIdBarang(response.data.idBarang);
        setJumlahStok(response.data.stok);
        setNamaBarang(response.data.namaBarang);
    };
    getBarangByIdBarang();
    
}


useEffect(() => {
    refreshToken();
    getBarang();
},[]);

// START ---TOKEN--- 
const refreshToken = async() => {
    try {
          const response = await axios.get(`${process.env.REACT_APP_MASTER_URL}/token`);
          setToken(response.data.accessToken);
          const decoded = jwt_decode(response.data.accessToken);
          // console.log("ini decode: ",decoded);
          setUser(decoded.username);
          setExpire(decoded.exp);
          
  
    } catch (error) {
        if(error.response){
          navigate("/login");
        }
    }
  }

  const axiosJWT = axios.create();

  axiosJWT.interceptors.request.use(async(config) => {
      const curretDate = new Date();
      if(expire * 1000 < curretDate.getTime()){
          const response = await axios.get(`${process.env.REACT_APP_MASTER_URL}/token`);
          config.headers.Authorization = `Bearer ${response.data.accessToken}`;
          setToken(response.data.accessToken);
          const decoded = jwt_decode(response.data.accessToken);
          // console.log(decoded);
          setUser(decoded.username);
          setExpire(decoded.exp);
      }
      return config;
  }, (error) => {
      return Promise.reject(error);
  });

// ----END---

const saveBarangMasuk = async (e) =>{
    e.preventDefault();
    setLoading(true)
    if(idBarang===null){
        alert("Silahkan Masukan Nama Barang...");
    }else{
    let formData = new FormData();
        formData.append('idBarang',idBarang);
        formData.append('namaBarang',namaBarang);
        formData.append('qty',qty);
        formData.append('suplier',suplier);
        formData.append('keterangan',keterangan);
        formData.append('user',user);
        formData.append('stok', parseInt(qty)+parseInt(jumlahstok));
    try {
        await axios.post(`${process.env.REACT_APP_MASTER_URL}/barangmasuk`,formData,{
            headers:{ 
                'Content-Type':'multipart/form-data'
            }
        });
        toast.info("Barang Masuk Ditambahkan");
        navigate("/barangmasuk")
    } catch (error) {
        setLoading(false)
        toast.error("Gagal, Kesalahan Server");
        console.log("error: ",error);
    }
        } 
}

  return (
    <section className="hero has-background-grey-light is-fullheight is-fullwidth">
        {loading ?
            <div style={stylespinner}>
                <PacmanLoader
                    color={'#301E67'}
                    loading={loading}
                    size={30}
                    textAlign='centered'
                    aria-label="Loading Spinner"
                    data-testid="loader"
                />
                </div> 
        :
        <div className="section is-fullheight" style={{backgroundColor: '#1b48f1', filterImage:'blur(50px)'}} >
        <div className="container ">
            <div className="column is-6 is-offset-3">
            <div className="box" >
                    <img src={`${process.env.REACT_APP_MASTER_URL}/assets/logonusamba.png`}  alt="Not Found" width={300} height={300}></img>
                    <label className='label' style={styleTittle}><center>BARANG MASUK</center></label>
                <form onSubmit={saveBarangMasuk}>
                    <div className='field'>
                        <label className='label'>Nama Barang</label>
                        <div class='control' has-icons-left has-icons-right>
                        <Select onChange={handleChange} options={options}/>
                        </div>
                    </div>
                    <div className='field'>
                        <label className='label'>Jumlah</label>
                        <div className='control'>
                            <input required type='number' className="input" value={qty} onChange={(e)=> setQty(e.target.value)} placeholder='Masukan Angka'></input>
                        </div>
                    </div>
                    <div className='field'>
                        <label className='label'>Suplier</label>
                        <div className='control'>
                            <input required type='text' className="input" value={suplier} onChange={(e)=> setSuplier(e.target.value)} placeholder='Pemohon  '></input>
                        </div>
                    </div>
                    <div className='field'>
                        <label className='label'>Keterangan</label>
                        <div className='control'>
                            <input type='text' className="input" value={keterangan} onChange={(e)=> setKeterangan(e.target.value)} placeholder='Opsional'></input>
                        </div>
                    </div>
                    <input  type='hidden' className="input" value={user} onChange={(e)=> setUser(e.target.value)} placeholder='Stok Saat Ini'></input>
                    <input  type='hidden' className="input" value={idBarang} onChange={(e)=> setIdBarang(e.target.value)} placeholder='Kode Barang'></input>
                    <div className='field mt-5'>
                        <button type='submit' className='button is-link'>Save</button>
                        <button type="button" onClick={() => navigate(-1)} className='button is-primary ml-5'>Back</button>
                    </div>
                </form>
            </div>
        </div>
        </div>
        </div>
    }
    </section>
  )
}

export default TambahBarang